module.exports = __webpack_public_path__ + "img/image37.242a906d.jpg";